module.exports = __webpack_public_path__ + "img/index-info3.0ec980c3.jpg";